import { debug } from "util";
import { fail } from "assert";

cb.define([], function () {
  var AA_aa_user_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      var self = this;
      viewmodel.on('afterLoadData', function () {
        // viewmodel.get('templates').setVisible(false);
        // viewmodel.get('btnSaveBo').setVisible(false);
        //将账号中的@符号以后的数据去掉
        var strCode = viewmodel.get("code").getValue();
        if (strCode != "" && strCode != null) {
          if (strCode.indexOf("@" + cb.rest.AppContext.tenant.alias) > 0) {
            viewmodel.get("code").setValue(strCode.replace("@" + cb.rest.AppContext.tenant.alias, ""))
          }
        }
        let mobileprenoModel = viewmodel.get('mobilepreno')
        let mobilepreno = mobileprenoModel.getValue();
        if (mobilepreno) {
          mobileprenoModel.setState('showValue', mobilepreno + ' ');
        } else {
          mobileprenoModel.setState('showValue', '86 ');
          mobileprenoModel.setState('value', '86');
        }
        //获取用户所属角色的折扣权限数据
        // if (viewmodel.getParams().mode == "browse") {
        // var proxy = cb.rest.DynamicProxy.create({
        // 				settle: {url: '/role/getRoleLocaleDiscountAuth', method: 'GET'}
        // 			});
        // var userid = viewmodel.get("id").getValue();
        // var params = {
        // 	 'opreatorId': userid
        // };
        // proxy.settle(params, function (err, result) {
        // if (err) {
        // 	cb.utils.alert(err.message, 'error');
        // 	return;
        // }
        // if (result != undefined) {
        // 	//var json = JSON.parse(result);
        // 	var json = result;
        // 	let data = json.localeDiscountData ? json.localeDiscountData : [];
        // 	viewmodel.get("userdiscounts").setDataSource(data);
        // }
        // });
        // }
      });
      // 手机号前缀
      viewmodel.get('mobilepreno') && viewmodel.get('mobilepreno').on('afterValueChange', (args) => {
        viewmodel.get('mobilepreno').setState('showValue', args.value.value + ' ');
      })
      viewmodel.on("modeChange", function (data) {
        //集成环境不显示门店和折扣权限分配
        // viewmodel.execute('updateViewMeta', { code: 'aa_user_tab_store', visible: false });
        // viewmodel.execute('updateViewMeta', { code: 'aa_user_tab_discount', visible: false });
        //}
      });
      var roleModel = viewmodel.get("roles");
      var orgModel = viewmodel.get("orgs");
      var storeModel = viewmodel.get("stores");
      var discountModel = viewmodel.get("userdiscounts");
      var warehouseModel = viewmodel.get("warehouses");
      if (roleModel) {
        roleModel.on('beforeCellValueChange', function (data) {
          switch (data.cellName) {
            case "role_name":
              {
                if (data.value.id != "") { //检查是否存在重复的数据
                  var length = this.getRows().length;
                  for (var i = 0; i < length; i++) {
                    if (i != data.rowIndex) {
                      if (data.value.id == this.getCellValue(i, 'role')) {
                        cb.utils.alert("已经分配该角色权限，请检查后重试！");
                        return false;
                      }
                    }
                  }
                }
                break;
              }
          }
        })
      }
      if (warehouseModel) {
        warehouseModel.on('beforeCellValueChange', function (data) {
          switch (data.cellName) {
            case "warehouse_code":
              {
                if (data.value.id != "") { //检查是否存在重复的数据
                  var length = this.getRows().length;
                  for (var i = 0; i < length; i++) {
                    if (i != data.rowIndex) {
                      if (data.value.id == this.getCellValue(i, 'warehouse')) {
                        cb.utils.alert("已经分配该仓库权限，请检查后重试！");
                        return false;
                      }
                    }
                  }
                }
                break;
              }
          }
        })
      }
      if (orgModel) {
        orgModel.on('beforeCellValueChange', (data) => {
          if (!data) return false;
          switch (data['cellName']) {
            case "org_code": {
              // lcccccc
              // let allData = orgModel.getAllData();
              // if (data.value.id != "") //检查是否存在重复的数据
              // {
              //   for (var i = 0; i < allData.length; i++) {
              //     let orgName = allData[i].org_name;
              //     let orgCode = allData[i].org_code;
              //     if (orgName != 'undefined') {
              //       if ((orgName == data.value.name) && (orgCode == data.value.code)) {
              //         cb.utils.alert("已经分配该组织权限！");
              //         return false;
              //       }
              //     }
              //   }
              // }


              // 判断 是不是唯一 并删除了改组织
              let _allOrgData = orgModel.getAllData();
              if (_allOrgData.length && JSON.stringify(data.value) == "{}") {
                cb.utils.alert('不能更改该组织', 'error');
                return false
              }
              let _index = data.rowIndex;
              let {result} = checkOrg(_index) || {};
              if (result && result.code !== 200) {
                cb.utils.alert('不能更改该组织', 'error');
                return false
              }
              break;
            }
            case "isdefault":
              {
                if (data.value.value == "true") //当默认选择是的情况下，处理所有其他行为否，并且设置表头默认组织id
                {
                  if (this.getCellValue(data.rowIndex, 'org')) //判断当前行组织是否没有填写
                  {
                    viewmodel.get("defaultorg").setValue(this.getCellValue(data.rowIndex, 'org'));
                    var length = this.getRows().length;
                    for (var i = 0; i < length; i++) {
                      if (i != data.rowIndex) {
                        this.setCellValue(i, 'isdefault', false);
                      }
                    }
                  }
                }
                break;
              }
            case "org_name":
              {
                if (data.value.id != "") //检查是否存在重复的数据
                {
                  var length = this.getRows().length;
                  for (var i = 0; i < length; i++) {
                    if (i != data.rowIndex) {
                      if (data.value.id == this.getCellValue(i, 'org')) {
                        cb.utils.alert("已经分配该组织权限，请检查后重试！");
                        return false;
                      }
                    }
                  }
                }
                break;
              }
          }

        })
        orgModel.on('beforeInsertRowsFromRefer', args => {
          var rows = orgModel.getRows();
          var delRows = [];
          rows.forEach((row,index) => {
            var org = row.org;
            if (org) {
              var i = args.rows.findIndex(e => e.org == org);
              if (i != -1) {
                args.rows.splice(i, 1);
              } else {
                delRows.push(index);
              }
            } else {
              delRows.push(index);
            }
          });
          if(delRows.length > 0) {
            setTimeout(() => {
              orgModel.deleteRows(delRows);
            }, 100);
          }
          if(args.rows.length > 0) {
            args.rows.forEach((row) => {
              orgModel.appendRow(row);
            });
          }
          return false;
          
        });
      }
      if (storeModel) {
        storeModel.on('beforeCellValueChange', function (data) {
          switch (data.cellName) {
            case "isdefault":
              {
                if (data.value.value == "true") //当默认选择是的情况下，处理所有其他行为否，并且设置表头默认门店id
                {
                  if (this.getCellValue(data.rowIndex, 'store')) //判断当前行门店是否没有填写
                  {
                    viewmodel.get("defaultstore").setValue(this.getCellValue(data.rowIndex, 'store'));
                    var length = this.getRows().length;
                    for (var i = 0; i < length; i++) {
                      if (i != data.rowIndex) {
                        this.setCellValue(i, 'isdefault', false);
                      }
                    }
                  }
                }
                break;
              }
            case "store_name":
              {
                if (data.value.id != "") //检查是否存在重复的数据
                {
                  var length = this.getRows().length;
                  for (var i = 0; i < length; i++) {
                    if (i != data.rowIndex) {
                      if (data.value.id == this.getCellValue(i, 'store')) {
                        cb.utils.alert("已经分配该门店权限，请检查后重试！");
                        return false;
                      }
                    }
                  }
                }
                break;
              }
          }

        });
        storeModel.on('beforeBrowse', function (data) {
          switch (data.cellName) {
            case "store_name":
              var orgid;
              var orglength = orgModel.getRows().length;
              var storelength = storeModel.getRows().length;
              var strOrgids = [];
              var strStoreids = [];
              if (orglength < 1) {
                cb.utils.alert("请先分配组织权限后重试！");
                return false;
              }
              for (var i = 0; i < orglength; i++) {
                strOrgids.push(orgModel.getCellValue(i, 'org'));
              }
              var condition = { "isExtend": true, simpleVOs: [] };
              condition.simpleVOs.push({ field: 'org', op: 'in', value1: strOrgids });
              for (var i = 0; i < storelength; i++) {
                if (storeModel.getCellValue(i, 'store') != null) { strStoreids.push(storeModel.getCellValue(i, 'store')); }
              }
              condition.simpleVOs.push({ field: 'id', op: 'nin', value1: strStoreids });
              var CusId = viewmodel.get("customer").getValue();
              if (CusId) {
                condition.simpleVOs.push({ field: 'cust', op: 'eq', value1: CusId });
              }
              data.context.setFilter(condition);
              break;
          }
        })
      }
      if (discountModel) {
        discountModel.on('beforeCellValueChange', function (data) {
          switch (data.cellName) {
            case "execdiscount":
              {
                if (this.getCellValue(data.rowIndex, 'productclass_name')) //判断当前行产品大类是否填写
                {
                  var length = this.getRows().length;
                  for (var i = 0; i < length; i++) {
                    if (i != data.rowIndex) {
                      if (self.booltostr(this.getCellValue(i, 'execdiscount')) == self.booltostr(data.value.value) && this.getCellValue(i, 'productclass') == this.getCellValue(data.rowIndex, 'productclass')) {
                        cb.utils.alert("[" + discountModel.getColumn("productclass_name").cShowCaption + "]与[" + discountModel.getColumn("execdiscount").cShowCaption + "]唯一性校验失败，请检查后重试！");
                        return false;
                      }
                    }
                  }
                }
                break;
              }
            case "productclass":
            case "productclass_name":
              {
                if (this.getCellValue(data.rowIndex, 'execdiscount')) //判断当前行执行会员折扣是否填写
                {
                  var length = this.getRows().length;
                  for (var i = 0; i < length; i++) {
                    if (i != data.rowIndex) {
                      var StrField;
                      StrField = "id";
                      if (this.getCellValue(i, 'execdiscount') == this.getCellValue(data.rowIndex, 'execdiscount') && this.getCellValue(i, "productclass") == data.value[StrField]) {
                        cb.utils.alert("[" + discountModel.getColumn("productclass_name").cShowCaption + "]与[" + discountModel.getColumn("execdiscount").cShowCaption + "]唯一性校验失败，请检查后重试！");
                        return false;
                      }
                    }
                  }
                }
                break;
              }
            case "discountdlimit":
              if (data.value < 0 || data.value > 100 || data.value == '-') {
                cb.utils.alert("[" + discountModel.getColumn("discountdlimit").cShowCaption + "]只能录入0~100之间的数据，请检查后重试！");
                return false;
              }
              break;
            case "ratediscountdlimit":
              if (data.value < 0 || data.value > 100 || data.value == '-') {
                cb.utils.alert("[" + discountModel.getColumn("ratediscountdlimit").cShowCaption + "]只能录入0~100之间的数据，请检查后重试！");
                return false;
              }
              break;
          }
        });
      }
      viewmodel.on('beforeSave', function (args) {
        if (self.savecheck(args, viewmodel) == false) {
          return false;
        }
      });
      viewmodel.on('beforeSaveandadd', function (args) {
        if (args.params.cAction == "saveandadd") {
          if (self.savecheck(args, viewmodel) == false) {
            return false;
          }
        }
      });
      const checkOrg = (index, callback) => {
        let _data = orgModel.getRow(index);
        let proxy = cb.rest.DynamicProxy.create({
          checkOrg: { url: '/user/checkBeforeDeleteUserOrg', method: 'POST', options: { async: false } }
        });
        return proxy.checkOrg(_data);
      }
      viewmodel.on('beforeDeleteRow', function (args) {
        if (args.params.key === 'btnDeleteRow_org') {
          let _allOrgData = orgModel.getAllData();
          if (_allOrgData.length <= 1) {
            cb.utils.alert('组织列表不能为空', 'error');
            return false
          }
          let _index = args.params.params.index;
          let data = checkOrg(_index) || {};
          let { result } = data;
          if (result) {
            switch (result.code) {
              case 999:
                cb.utils.alert(result.message, 'error');
                break;
              case 200:
                orgModel.deleteRows(_index);
                break;
            }
          }
          return false
        }
      });

      viewmodel.on('beforeAddRow', function (args) {
        console.log("增行");
        //当前登录用户的用户类型 lcccc
        let userType = cb.rest.AppContext.user.userType;
        console.log(userType);
        if (userType == 4) {
          // cb.utils.alert('商家管理员新增商家操作员时不能给商家操作员分配角色（权限）', 'warning');
          // return false;
        }
      });

      //数据加载后
      // discountModel.on('afterMount', function () {
      //   if (cb.rest.AppContext.tenant.industry == 17 || cb.rest.AppContext.tenant.industry == '17') {
      //     discountModel.setColumnState("golddiscountulimit", "bShowIt", true);
      //     discountModel.setColumnState("ratediscountdlimit", "bShowIt", true);
      //   } else {
      //     discountModel.setColumnState("golddiscountulimit", "bShowIt", false);
      //     discountModel.setColumnState("ratediscountdlimit", "bShowIt", false);
      //   }
      // });
    },
    booltostr: function (value) {
      var returnvalue = '';
      if (cb.utils.isEmpty(value)) return returnvalue;
      returnvalue = String(value).toLowerCase();
      return returnvalue;
    },
    savecheck: function (args, viewmodel) {
      var that = this;
      var irow;
      var jrow;
      var roleModel = viewmodel.get("roles");
      var orgModel = viewmodel.get("orgs");
      var storeModel = viewmodel.get("stores");
      var discountModel = viewmodel.get("userdiscounts");
      var warehouseModel = viewmodel.get("warehouses");
      //检查账号长度
      var userdata = JSON.parse(args.data.data);
      var usercode;
      var usern = /^[a-zA-Z0-9]{1,}$/;
      usercode = userdata["code"];
      if (!usercode) return true;
      //if (!usercode.match(usern) || usercode.length < 4 || usercode.length > 18) {
      //	cb.utils.alert("账号只能为4~18位数字或字母，请检查后重试！");
      //	return false;
      //}
      //将账号中的@符号以后的数据补充上
      if (usercode.indexOf("@" + cb.rest.AppContext.tenant.alias) < 0) {
        userdata["code"] = usercode + "@" + cb.rest.AppContext.tenant.alias;
        args.data.data = JSON.stringify(userdata);
      }

      //检查角色
      if (roleModel) {
        var roleModellength = roleModel.getRows().length;
        for (var i = 0; i < roleModellength; i++) {
          for (var j = i + 1; j < roleModellength; j++) { //双循环中处理重复校验
            if (roleModel.getCellValue(i, 'role') == roleModel.getCellValue(j, 'role')) {
              irow = i + 1;
              jrow = j + 1;
              cb.utils.alert("第" + irow + "行[" + roleModel.getColumn("role_name").cShowCaption + "]与第" + jrow + "行重复，请检查后重试！");
              return false;
            }
          }
        }
      }
      //检查角色
      if (warehouseModel) {
        var warehouseModellength = warehouseModel.getRows().length;
        for (var i = 0; i < warehouseModellength; i++) {
          for (var j = i + 1; j < warehouseModellength; j++) { //双循环中处理重复校验
            if (warehouseModel.getCellValue(i, 'warehouse') == warehouseModel.getCellValue(j, 'warehouse')) {
              irow = i + 1;
              jrow = j + 1;
              cb.utils.alert("第" + irow + "行[" + warehouseModel.getColumn("warehouse_name").cShowCaption + "]与第" + jrow + "行重复，请检查后重试！");
              return false;
            }
          }
        }
      }
      //检查组织项
      if (orgModel) {
        var orgModellength = orgModel.getRows().length;
        if (orgModellength < 1) {
          cb.utils.alert("组织权限必须分配，请检查后重试！");
          return false;
        }
        for (var i = 0; i < orgModellength; i++) {
          for (var j = i + 1; j < orgModellength; j++) { //双循环中处理重复校验
            if (orgModel.getCellValue(i, 'org') == orgModel.getCellValue(j, 'org')) {
              irow = i + 1;
              jrow = j + 1;
              cb.utils.alert("第" + irow + "行[" + orgModel.getColumn("org_name").cShowCaption + "]与第" + jrow + "行重复，请检查后重试！");
              return false;
            }
          }
        }
      }
      //检查门店
      if (storeModel) {
        var storeModellength = storeModel.getRows().length;
        for (var i = 0; i < storeModellength; i++) {
          for (var j = i + 1; j < storeModellength; j++) { //双循环中处理重复校验
            if (storeModel.getCellValue(i, 'store') == storeModel.getCellValue(j, 'store')) {
              irow = i + 1;
              jrow = j + 1;
              cb.utils.alert("第" + irow + "行[" + storeModel.getColumn("store_name").cShowCaption + "]与第" + jrow + "行重复，请检查后重试！");
              return false;
            }
          }
        }
      }
      //检查折扣
      if (discountModel) {
        var discountModellength = discountModel.getRows().length;
        for (var i = 0; i < discountModellength; i++) {
          for (var j = i + 1; j < discountModellength; j++) { //双循环中处理重复校验
            if (discountModel.getCellValue(i, 'productclass') == discountModel.getCellValue(j, 'productclass') && that.booltostr(discountModel.getCellValue(i, 'execdiscount')) == that.booltostr(discountModel.getCellValue(j, 'execdiscount'))) {
              irow = i + 1;
              jrow = j + 1;
              cb.utils.alert("第" + irow + "行[" + discountModel.getColumn("productclass_name").cShowCaption + "]+[" + discountModel.getColumn("execdiscount").cShowCaption + "]与第" + jrow + "行重复，请检查后重试！");
              return false;
            }
          }
          var therow;
          if (cb.rest.AppContext.tenant.industry == 17 || cb.rest.AppContext.tenant.industry == '17') {
            //检查必填 珠宝行业 折扣额下限 金价折扣额上限（元/克） 工费折扣率下限（%） 三者必有其一
            if ((!discountModel.getCellValue(i, 'discountdlimit') || discountModel.getCellValue(i, 'discountdlimit') == "") && (!discountModel.getCellValue(i, 'golddiscountulimit') || discountModel.getCellValue(i, 'golddiscountulimit') == "") && (!discountModel.getCellValue(i, 'ratediscountdlimit') || discountModel.getCellValue(i, 'ratediscountdlimit') == "")) {
              therow = i + 1;
              cb.utils.alert("第" + therow + "行[" + discountModel.getColumn("discountdlimit").cShowCaption + "、" + discountModel.getColumn("golddiscountulimit").cShowCaption + "、" + discountModel.getColumn("ratediscountdlimit").cShowCaption + "]必填其一，请检查后重试！");
              return false;
            }
          } else {
            if ((!discountModel.getCellValue(i, 'discountdlimit') || discountModel.getCellValue(i, 'discountdlimit') == "")) {
              therow = i + 1;
              cb.utils.alert("第" + therow + "行[" + discountModel.getColumn("discountdlimit").cShowCaption + "]必填，请检查后重试！");
              return false;
            }
          }

        }
      }
    }
  }
  try {
    module.exports = AA_aa_user_VM_Extend;
  } catch (error) {}
  return AA_aa_user_VM_Extend;
});

//cb.namespace('biz.AA');
//cb.biz.AA.AA_aa_bankaccount_VM_Extend = AA_aa_bankaccount_VM_Extend;

//export default AA_aa_bankaccount_VM_Extend



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_user_VM.Extend.js